export default __webpack_public_path__ + "static/N0283-4e019999b39d53b767c5854fc6b81f0e.png";